"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _ramda = require("ramda");

var _mediaQueries = _interopRequireDefault(require("./media-queries"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var breakpoints = {
  deskWide: 50,
  desktop: 45,
  palm: 25,
  portable: 30
};

var _default = function _default(bot, top) {
  if (bot === void 0) {
    bot = 0;
  }

  if (top === void 0) {
    top = 0;
  }

  return (0, _ramda.map)(function (breakpoint) {
    return (0, _styledComponents.css)(["", ";"], _mediaQueries["default"][breakpoint](_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding-bottom: ", "px;\n  padding-top: ", "px;\n  "])), bot * breakpoints[breakpoint], top * breakpoints[breakpoint]));
  }, (0, _ramda.keys)(breakpoints));
};

exports["default"] = _default;